export class SimularUsuario{
    public id: number;
    public observacao: string;
    public id_usuario_simulado: number;
    public id_usuario_simulou: number;
    public data_simulacao: Date;
    public ativo: boolean;

    constructor(id_usuario_logado: number, id_usuario_simulado, observacao: string, ativo: boolean) {
        this.observacao = observacao;
        this.id_usuario_simulou = id_usuario_logado;
        this.id_usuario_simulado = id_usuario_simulado;
        this.ativo = ativo;
        this.data_simulacao = new Date();
    }
}



// WEBPACK FOOTER //
// ./src/app/entity/simular-usuario.model.ts